import $ from 'jquery';
import logger from '../core/logger';

function sendClickLogOnClick(eventTarget, params, e, rc, at = 'link') {
  const linkElem = (eventTarget.nodeName && eventTarget.nodeName === 'A') ? eventTarget : eventTarget.querySelector('a');
  const thumbData = e.imageData;
  const ndid64Str = thumbData.ndid64 || '';
  const logParams = {
    d   : thumbData.docid,
    p   : params.p,
    r   : thumbData.index + 1,
    rc,
    pg  : thumbData.page,
    e1  : thumbData.info.cpid,
    ext : `dsid=${thumbData.docid}__DeLiM__ndid64=${ndid64Str}`,
    at
  };

  logger.sendClickLog(linkElem, logParams, e.originalEvent, {
    img: {
      cpid: thumbData.info.cpid,
      ndid64: ndid64Str
    }
  });
}

function onThumbClick(imageApp) {
  imageApp.thumbBoard.$board.on('thumb:click', function (e) {
    const rc = $.map(imageApp.thumbBoard.data, (item) => {
      return item.hide === 'Y' ? null : item;
    }).length;
    sendClickLogOnClick(e.targetLink, {p: 1}, e, rc);
  });
}

function onExtenderClick(imageApp) {
  imageApp.btnExtend.$elem.on('click', function (e) {
    const clickCnt = imageApp.state.moreBtnClickCnt;
    const extendECode = 10;
    const foldECode = 21;
    const logParams = {
      pg: 1,
      rc: 1,
      at: 'func'
    };

    logParams.e = clickCnt > 0 ? extendECode + clickCnt - 1 : foldECode;

    logger.sendClickLog(this, logParams, e);
  });
}

function onMoreLinkButtonClick($imageColl) {
  const $btnMore = $imageColl.find('.extend_comp .expender.more');
  $btnMore.on('click', function (e) {
    const logParams = {
      e: 1,
      rc: 1,
      at: 'more'
    };
    logger.sendClickLog(this, logParams, e);
  });
}

export default function initLog($imageColl, imageApp) {
  logger.setBasicCode('s', 'TO');
  onThumbClick(imageApp);
  onExtenderClick(imageApp);
  onMoreLinkButtonClick($imageColl);
}


/** WEBPACK FOOTER **
 ** ./src/IIM/tot/log.js
 **/